import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { StorageDataService } from "../storage/storage-data.service";
import { ShellDomainProvider } from "../utility/shell-domain.provider";

@Injectable({ providedIn: 'root' })
export class DownloadService {

  constructor(private http: HttpClient,
    private storageService: StorageDataService) { }

  getBlob(url: string): Observable<Blob> {
    return this.http.get(url, {
      withCredentials: true,
      responseType: 'blob'
    })
  }

  download(blob: Blob, filename?: string): void {
    const a = document.createElement('a')
    const objectUrl = URL.createObjectURL(blob)
    a.href = objectUrl
    a.download = filename ? filename : 'download';
    a.click();
    URL.revokeObjectURL(objectUrl);
  }

  downloadBlobByFileId(fileId: string) {
    let fileName = 'download';
    return this.storageService.getFilesInfo([fileId]).pipe(switchMap((response: any) => {
      if (response && response["body"].length === 0)
        return of(false);

      const file = response.body[0];
      if (ShellDomainProvider['api']['IsStaging'])
        file.Url = file.Url.replace("http://", "https://");

      fileName = file.Name;

      return this.getBlob(file.Url);

    })).pipe(map((blob: any) => {
      if (!blob)
        return false;

      this.download(blob, fileName);

      return true;
    }))
  }

  downloadBlobByUrl(fileUrl: string, fileName: string) {
    return this.getBlob(fileUrl).pipe(map((blob: any) => {
      if (!blob)
        return false;

      this.download(blob, fileName);

      return true;
    }))
  }

}
